import Image from 'next/image';

// Components
import H1 from '@/components/base/Headings/H1';

type RegularEmptyStateProps = {
    tag?: React.ReactNode;
    title: string;
    description: string;
    cards?: {
        title: string;
        description: string;
    }[];
    children?: React.ReactNode;
};

export function RegularEmptyState({
    tag,
    title,
    description,
    cards,
    children
}: RegularEmptyStateProps) {
    return (
        <div className="h-full @container">
            <div className="flex h-full flex-col gap-20 rounded-xl bg-white p-10 @xl:p-20 dark:bg-icoDarkMode-deepBlack">
                <div className="flex flex-col justify-between gap-[60px] @5xl:flex-row">
                    <div className="flex max-w-[320px] flex-col gap-10 @5xl:w-1/2">
                        <div className="flex flex-col gap-6">
                            {tag ? (
                                <div>
                                    <span className="rounded-3xl bg-icoBlue-100 px-4 py-3 text-xxs font-semibold uppercase text-icoBlue dark:bg-icoBlue/20">
                                        {tag}
                                    </span>
                                </div>
                            ) : null}
                            <H1>{title}</H1>
                            <p className="font-GMedium text-xl text-icoGray-500 dark:text-icoDarkMode-wolf">
                                {description}
                            </p>
                        </div>
                        {children}
                    </div>
                    <div className="relative @5xl:w-1/2">
                        <div className="relative h-full w-full overflow-hidden rounded-3xl backdrop-opacity-50">
                            <div className="relative aspect-[875/494] h-full min-h-[500px] w-full @5xl:min-w-[800px]">
                                <Image
                                    src="/images/illustrations/empty-states/empty-state-multi-profiles.png"
                                    alt="illustration"
                                    className="max-w-none rounded-2xl"
                                    fill
                                    objectFit="cover"
                                    objectPosition="top left"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {cards ? (
                    <div className="flex flex-col gap-5 text-sm @[900px]:flex-row">
                        {cards.map((card, index) => (
                            <div
                                key={card.title}
                                className="bg- flex flex-col gap-1 rounded-lg bg-icoGray-100 p-6 dark:bg-icoDarkMode-anthracite">
                                <h3 className="font-GBold text-xl">
                                    <span className="text-icoBlue">{index + 1}.</span> {card.title}
                                </h3>
                                <p className="text-icoGray-500 dark:text-icoDarkMode-wolf">
                                    {card.description}
                                </p>
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
    );
}
